import { Component, EventEmitter, Input, Output } from "@angular/core";

import { PRICELIST_CARD_TEXT } from "../../constants/pricelist.constants";
import { ExportFormat } from "../../types/export-format.types";
import { PublishedPricelist } from "../../types/pricelist.types";
import { formatLeadTimeWeeksLabel } from "../../utils/lead-time-weeks.util";
import { getVolumeDiscountTeaser } from "../../utils/volume-discount.utils";

@Component({
    selector: "vsf-pricelist-card",
    templateUrl: "./pricelist-card.component.html",
    styleUrls: ["./pricelist-card.component.scss"],
})
export class PricelistCardComponent {
    @Input() pricelist: PublishedPricelist;
    @Input() isPreOrder = true;

    @Output() viewClick = new EventEmitter<PublishedPricelist>();
    @Output() downloadClick = new EventEmitter<{
        pricelist: PublishedPricelist;
        format: ExportFormat;
    }>();
    @Output() shareClick = new EventEmitter<{
        pricelist: PublishedPricelist;
        format: ExportFormat;
    }>();

    readonly TEXT = PRICELIST_CARD_TEXT;

    getTitle = (): string =>
        this.isPreOrder ? PRICELIST_CARD_TEXT.PRE_ORDER_TITLE : PRICELIST_CARD_TEXT.STOCK_TITLE;

    getMovDisplay = (): string => {
        if (this.pricelist?.mov === null || this.pricelist?.mov === undefined) {
            return "-";
        }
        return `€${(this.pricelist.mov / 100).toLocaleString()}`;
    };

    getVolumeDiscountTeaser = (): string | null =>
        getVolumeDiscountTeaser(this.pricelist?.volumeDiscounts);

    getShippingDisplay = (): string | null => {
        if (this.isPreOrder && this.pricelist?.preOrderShippingDate) {
            return this.pricelist.preOrderShippingDate;
        }

        if (!this.isPreOrder && (this.pricelist?.leadTimeFrom || this.pricelist?.leadTimeTo)) {
            const label = formatLeadTimeWeeksLabel(
                this.pricelist.leadTimeFrom,
                this.pricelist.leadTimeTo,
            );
            if (label !== "—") {
                return `Est. ${label}`;
            }
        }

        return null;
    };

    onViewClick = (): void => {
        this.viewClick.emit(this.pricelist);
    };

    onDownloadClick = (format: ExportFormat): void => {
        this.downloadClick.emit({ pricelist: this.pricelist, format });
    };

    onShareClick = (format: ExportFormat): void => {
        this.shareClick.emit({ pricelist: this.pricelist, format });
    };
}
